export const productShortName = 'Industria Mineraria e Risorse Minerali — Edizione Docenti';
export const productBrand = 'Industria Mineraria e Risorse Minerali';
export const productEdition = 'Edizione Docenti';
export const productImage = 'https://cdn.magicpatterns.com/uploads/k2BUnezhgUnZUyYqKT4DmG/MOCKUP_MINIERA_1400.png';
export const productImageAlt =
  'Industria Mineraria e Risorse Minerali Edizione Docenti: collezione didattica in 6 volumi con 5 risorse bonus';

export const checkoutUrl = 'https://industria-mineraria-docenti.impultienda.ar/checkout';

export const price = '€27';
export const priceBefore = '€80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '€17';
export const bonusTotalValue = '€85';

export const assurances = ['Pagamento sicuro', 'Accesso immediato', 'Garanzia di 7 giorni'];

export const closingLines = [
  'Basta preparare ogni lezione sulle miniere da zero',
  'Basta spiegare giacimenti ed estrazione senza materiali chiari',
  'Basta cercare attività e casi di studio sparsi su internet',
  "Basta verifiche improvvisate all'ultimo minuto",
  'Basta studenti distratti durante le lezioni di scienze e tecnologia',
];
